import { useEffect } from 'react';
import { usePanelType } from './hooks/usePanelType';
import { envVariables } from './envConfig/envVariables';

function Analytics() {
  const panelType = usePanelType();

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') return;
    if (!(envVariables && envVariables.prd && envVariables.prd[panelType] && envVariables.prd[panelType].ANALYTICS_ID)) return;

    const loadAnalytics = () => {
      const gtagScript = document.createElement('script');
      gtagScript.async = true;
      gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${envVariables.prd[panelType].ANALYTICS_ID}`;
      document.head.appendChild(gtagScript);

      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      gtag('js', new Date());
      gtag('config', envVariables.prd[panelType].ANALYTICS_ID);
    };

    loadAnalytics();
  }, [panelType]);

  return null;
}

export default Analytics;
